webpackJsonp([62780930544359],{

/***/ 1718:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Conditional","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"operator","type":{"kind":"ENUM","name":"ConditionalOperator","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"productId","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"quantity","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-conditional-c8f4f627ee24350d4abb.js